import { useSuspenseQuery } from '@tanstack/react-query';

import type { Site, Space } from '@gitbook/api-client';

import { useSpacePrimarySite } from '../../../../../Components';
import { apiQuery } from '../../../../../state';

export type AdaptiveContentContext = {
    site: Site;
    organizationId: string;
} | null;

/**
 * Hook to get the adaptive content context for a space.
 */
export function useAdaptiveContextForSpace(space: Space): AdaptiveContentContext {
    const { data: organizationContent } = useSuspenseQuery(
        apiQuery('getOrganizationAllContent', {
            organizationId: space.organization,
        })
    );
    const spacePrimarySiteLookup = useSpacePrimarySite(organizationContent, space.id);

    return spacePrimarySiteLookup
        ? {
              site: spacePrimarySiteLookup.site,
              organizationId: space.organization,
          }
        : null;
}
